import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import React, { useState } from "react";
import { saveUserValue } from "../api/UserSetups";

interface RowSelectorProps {
  rowsToShow: number;
  setRowsToShow: (value: number) => void;
}

const ShowQueryDataResult: React.FC<RowSelectorProps> = ({
  rowsToShow,
  setRowsToShow,
}) => {
  const [showLoading, setShowLoading] = useState(false);

  const onRowsToShowChange = async (value: number) => {
    const data = {
      UserParameter: "rows_to_show",
      UserSection: "QuerySettings",
      UserValue: value,
    };
    setShowLoading(true);
    await saveUserValue(data);
    setShowLoading(false);
  };

  const handleSelectionChange = async (value: number) => {
    setRowsToShow(value);
    await onRowsToShowChange(value);
  };

  return (
    <IonItem>
      <IonLabel position="stacked">Number of Rows to Display in Query Results</IonLabel>
      <IonSelect
        interface="popover"
        value={rowsToShow}
        onIonChange={(event) => handleSelectionChange(event.detail.value)}
      >
        <IonSelectOption value={50}>50 Rows</IonSelectOption>
        <IonSelectOption value={100}>100 Rows</IonSelectOption>
        <IonSelectOption value={200}>200 Rows</IonSelectOption>
        <IonSelectOption value={500}>500 Rows</IonSelectOption>
      </IonSelect>
    </IonItem>
  );
};

export default ShowQueryDataResult;